"use strict";
$(document).ready(() => {
    // console.log('in linkedin redirect file');
    let linkedInIcons = [];
    const linkedInIconsIntroPara = document.querySelectorAll('.intro-para .icon-li');
    const linkedInIconsEventAgenda = document.querySelectorAll('.section-events-listing .event-section .social-nav .icon-li');
    const linkedInIconsArticleContent = document.querySelectorAll('.article-main-content .icon-li');
    // console.log(linkedIcons);
    if (linkedInIconsIntroPara && linkedInIconsIntroPara.length > 0) {
        linkedInIcons = [
            ...linkedInIcons,
            ...linkedInIconsIntroPara,
        ];
    }
    if (linkedInIconsEventAgenda && linkedInIconsEventAgenda.length > 0) {
        linkedInIcons = [
            ...linkedInIcons,
            ...linkedInIconsEventAgenda,
        ];
    }
    if (linkedInIconsArticleContent && linkedInIconsArticleContent.length > 0) {
        linkedInIcons = [
            ...linkedInIcons,
            ...linkedInIconsArticleContent,
        ];
    }
    linkedInIcons.forEach(iconItem => {
        const anchorElement = iconItem.parentNode;
        const shareUrl = window.location.href;
        // console.log(shareUrl);
        const encodedLink = encodeURI(shareUrl);
        // console.log(encodedLink);
        const linkedinShareUrl = `https://www.linkedin.com/shareArticle?url=${encodedLink}`;
        anchorElement.href = linkedinShareUrl;
        // anchorElement.addEventListener('click', (e) => {
        //    e.preventDefault();
        //    // const currentHref = anchorElement.href;
        //    // console.log(currentHref);
        //    // const urlParams = new URL(currentHref).searchParams;
        //    // const shareUrl = urlParams.get('url');
        //
        //    window.open(linkedUrl, '_blank');
        // })
    });
});
